import {NgModule} from '@angular/core';
import {GreydomCommonModule} from '../../common/modules/greydom-common.module';
import {
  ApplicationsComponent,
  BrokersComponent,
  ReviewApplicationComponent,
  ApplicationAddressesComponent,
  ApplicationBankDetailsComponent,
  ApplicationDocumentsComponent,
  ApplicationEmailsComponent,
  ApplicationFamilyProvidersComponent,
  ApplicationSmsesComponent,
  ApplicationSummaryComponent,
  ApplicationPersonsComponent,
  PersonContactsComponent,
  PersonConditionsComponent,
  PersonSchemeHistoryComponent,
  PersonEmploymentDetailsComponent,
  AddEditBrokerComponent,
} from '../../onboarding-admin-portal/components';
import {
  PolicyholderGroupsComponent
} from '../../onboarding-admin-portal/components/pages/policyholder-groups/policyholder-groups.component';
import {RulesEngineMetadataManagementViewComponent} from '../../other/components/pages/rules-engine-metadata/rules-engine-metadata-management-view.component';
import {ReportingViewComponent} from '../../other/components/pages/reporting-view/reporting-view.component';
import {SmsTableComponent} from '../../common/components/sms-table/sms-table.component';
import {EmailTableComponent} from '../../common/components/email-table/email-table.component';
import {
  UnderwritingConcessionDialogComponent
} from '../../common/dialogs/underwriting-concession-dialog/underwriting-concession-dialog.component';
import {
  PersonsComponent
} from '../../ent/components/pages/enterprise-management-view/persons/persons-component/persons.component';

//  Exported Components
const componentsToExport: any[] = [
  ApplicationsComponent,
  BrokersComponent,
  AddEditBrokerComponent,
  PolicyholderGroupsComponent,
  ReportingViewComponent,
  ReviewApplicationComponent,
  RulesEngineMetadataManagementViewComponent,
  SmsTableComponent,
  EmailTableComponent,
  PersonsComponent
];


// Internal Components for Module declarations
const componentsInternalRegister: any[] = [
  ApplicationSummaryComponent,
  ApplicationBankDetailsComponent,
  ApplicationAddressesComponent,
  ApplicationDocumentsComponent,
  ApplicationFamilyProvidersComponent,
  ApplicationPersonsComponent,
  PersonContactsComponent,
  PersonConditionsComponent,
  PersonSchemeHistoryComponent,
  PersonEmploymentDetailsComponent,
  ApplicationSmsesComponent,
  ApplicationEmailsComponent,
];

const components: any[] = [
  ...componentsToExport,
  ...componentsInternalRegister
];

const modules: any[] = [
  GreydomCommonModule
];

const dialogs = [
  UnderwritingConcessionDialogComponent
];

@NgModule({
  declarations: [...components, ...dialogs],
  imports: [...modules],
  exports: [...componentsToExport, ...modules]
})

export class EntPartialModule {
}
